import ModalDeleteFilled from '../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'


interface ModalEditActiveProductInnerProps extends ModalEditComponentProps { }

const ModalEditActiveProductInner: React.FC<ModalEditActiveProductInnerProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/product/updateProduct',
        data: {
            active: true,
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureActivateProduct', '¿Seguro quieres reactivar este producto?'),
            subtitle: t('onceActivatedShowList', 'Una vez reactivado aparecerá en tu lista de productos'),
            buttonAccept:  t('accept', 'Aceptar'),
            buttonCancel: t('cancel', 'Cancelar')
        }} />
    )
}

export default ModalEditActiveProductInner